module.exports = __webpack_public_path__ + "static/media/link.665a8aa5.svg";